var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7812 5.8335H14.2188C9.57836 5.8335 7.25817 5.8335 5.81658 7.29796C4.375 8.76243 4.375 11.1195 4.375 15.8335V19.1668C4.375 23.8809 4.375 26.2379 5.81658 27.7024C7.25817 29.1668 9.57836 29.1668 14.2188 29.1668H20.7812C25.4216 29.1668 27.7418 29.1668 29.1834 27.7024C30.625 26.2379 30.625 23.8809 30.625 19.1668V15.8335C30.625 11.1195 30.625 8.76243 29.1834 7.29796C27.7418 5.8335 25.4216 5.8335 20.7812 5.8335Z",
    stroke: "#0B6BDD",
    strokeWidth: 2.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.207 11.6665H14.582",
    stroke: "#0B6BDD",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7083 23.3337H24.7917C24.1167 23.3337 23.7792 23.3337 23.5022 23.26C22.7434 23.058 22.1508 22.4653 21.9487 21.7066C21.875 21.4296 21.875 21.0921 21.875 20.4171C21.875 19.7421 21.875 19.4046 21.9487 19.1276C22.1508 18.3688 22.7434 17.7762 23.5022 17.5742C23.7792 17.5004 24.1167 17.5004 24.7917 17.5004H27.7083C28.3833 17.5004 28.7208 17.5004 28.9978 17.5742C29.7566 17.7762 30.3492 18.3688 30.5513 19.1276C30.625 19.4046 30.625 19.7421 30.625 20.4171C30.625 21.0921 30.625 21.4296 30.5513 21.7066C30.3492 22.4653 29.7566 23.058 28.9978 23.26C28.7208 23.3337 28.3833 23.3337 27.7083 23.3337Z",
    stroke: "#0B6BDD",
    strokeWidth: 2.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletAlt);
export default __webpack_public_path__ + "static/media/Wallet_alt.27e8bbb5b047d5ddafb08d816a6b6e7e.svg";
export { ForwardRef as ReactComponent };